import { useCallback } from 'react';
import type { GetPermanentAccessTokenHandler } from '@ankr.com/auth';
import {
  getPermanentAccessToken,
  signOut,
  useAuth as useAuthHook,
} from '@ankr.com/auth';
import { getErrorMessage } from '@ankr.com/raas-utils';
import * as Sentry from '@sentry/react';

import { Gateways } from '../../api';
import { AUTH_API, AUTH_APP_ID } from '../const';
import { handlePermanentTokenError } from '../utils/handlePermanentTokenError';

export function useAuth() {
  const getPermanentToken = useCallback<GetPermanentAccessTokenHandler>(
    async params => {
      try {
        return await getPermanentAccessToken(params);
      } catch (error) {
        Sentry.withScope(scope => {
          scope.setExtra('reason', 'Failed to get useAuth');
          Sentry.captureException(error);
        });

        handlePermanentTokenError({ error });

        throw new Error(getErrorMessage(error));
      }
    },
    [],
  );

  return useAuthHook({
    appId: AUTH_APP_ID,
    getPermanentAccessToken: getPermanentToken,
    signOutFromAPI: signOut,
    gateways: Gateways,
    customAuthAPIBaseURL: AUTH_API,
  });
}
